<div class="fill-vert flex-column scroll-overflow">
    <div class="scroll-overflow" style="height: 70%; max-height:70%; min-height:70%;">
        <p-accordion>
            <p-accordionTab header="Search Criteria" [selected]="!resultsPanelVisible"
                (onOpen)="resultsPanelVisible = false;">
                <div class=" col scroll-overflow">
                    <p-accordion>
                        <p-accordionTab header="Step 1 - Procedure Selection" [(selected)]="stepStates[0]">
                            <app-procedure-selector [(category)]="selectedCategory" [procedures]="selectedProcs"
                                (proceduresChange)="selectedProcsChanged($event)"></app-procedure-selector>
                        </p-accordionTab>
                        <p-accordionTab header="Step 2 - Select Source and Network" [(selected)]="stepStates[1]">

                            <!-- Source -->
                            <div class="formgroup-inline mt-3">
                                <p-dropdown appendTo="body" id="Source" [options]="sources" [(ngModel)]="selectedSource"
                                    optionLabel="sourceName" [style]="{'width':'200px'}" [showClear]="true"
                                    placeholder="Select Source"></p-dropdown>
                                <p-dropdown appendTo="body" id="Network" [options]="networks"
                                    [(ngModel)]="selectedNetwork" optionLabel="displayName" [style]="{'width':'200px'}"
                                    [showClear]="true" placeholder="Select Network"></p-dropdown>
                            </div>

                            <!-- Network -->
                        </p-accordionTab>
                        <p-accordionTab header="Step 3 - Select Search Area and Lookback" [(selected)]="stepStates[2]">
                            <div class="formgroup-inline mt-3">
                                <span class="p-float-label">
                                    <input id="zipCode" type="text" pInputText [(ngModel)]="zipCode" />
                                    <label for="zipCode">Zip Code</label>
                                </span>
                                <span class="p-float-label">
                                    <!--<p-inputNumber [(ngModel)]="radius" inputId="radius" suffix=" mi"></p-inputNumber>-->
                                    <input id="radius" type="number" pInputText [(ngModel)]="radius" />
                                    <label for="radius">Radius (mi)</label>
                                </span>
                                <span class="p-float-label">
                                    <input id="lookback" type="number" pInputText [(ngModel)]="lookbackDays" />
                                    <label for="lookback">Lookback Days</label>
                                </span>
                            </div>
                            <p-button label="Go!" (click)="doLookup()" [disabled]="searching" iconPos="right"
                                [icon]="searchIcon"></p-button>
                        </p-accordionTab>
                    </p-accordion>
                </div>
            </p-accordionTab>
            <p-accordionTab header="Search Results" [(selected)]="resultsPanelVisible">
                <div class="col scroll-overflow">
                    <p-accordion [activeIndex]="selectedResultSet">
                        <p-accordionTab header="Specific Results">
                            <p-tabView [activeIndex]="selectedResultsType">
                                <p-tabPanel header="Procedure Results">
                                    <app-procedure-results [procedureResults]="lookupResults?.specificProcedureResults"
                                        (chosenResult)="chosenPracticeResult($event.chosenResult); chosenSpecificProcs($event.chosenItems);"></app-procedure-results>
                                </p-tabPanel>
                                <p-tabPanel header="Category Results">
                                    <app-category-results [categoryResults]="lookupResults?.specificCategoryResults"
                                        (chosenResult)="chosenPracticeResult($event.chosenResult); chosenSpecificCats($event.chosenItems);"></app-category-results>
                                </p-tabPanel>
                                <p-tabPanel header="Instance Results">
                                    <app-instance-results [instanceResults]="lookupResults?.specificInstanceResults"
                                        (chosenResult)="chosenPracticeResult($event.chosenResult); chosenSpecificInstances($event.chosenItems);"></app-instance-results>
                                </p-tabPanel>
                            </p-tabView>
                        </p-accordionTab>
                        <p-accordionTab header="General Results">
                            <p-tabView [activeIndex]="selectedResultsType">
                                <p-tabPanel header="Procedure Results">
                                    <app-procedure-results [procedureResults]="lookupResults?.generalProcedureResults"
                                        (chosenResult)="chosenPracticeResult($event.chosenResult); chosenGeneralProcs($event.chosenItems);"></app-procedure-results>
                                </p-tabPanel>
                                <p-tabPanel header="Category Results">
                                    <app-category-results [categoryResults]="lookupResults?.generalCategoryResults"
                                        (chosenResult)="chosenPracticeResult($event.chosenResult); chosenGeneralCats($event.chosenItems);"></app-category-results>
                                </p-tabPanel>
                                <p-tabPanel header="Instance Results">
                                    <app-instance-results [instanceResults]="lookupResults?.generalInstanceResults"
                                        (chosenResult)="chosenPracticeResult($event.chosenResult); chosenGeneralInstances($event.chosenItems);"></app-instance-results>
                                </p-tabPanel>
                            </p-tabView>
                        </p-accordionTab>
                        <p-accordionTab header="MRF Results">
                            <p-table *ngIf="mrfResults != null" [value]="mrfResults" dataKey="practice.ein"
                                selectionMode="single" [(selection)]="selectedMRFResult"
                                (onRowSelect)="MRFChosen($event)" (onRowUnselect)="MRFChosen($event)"
                                sortField="practice.practiceName">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width: 3rem;"></th>
                                        <th pSortableColumn="practice.practiceName">Practice Name <p-sortIcon
                                                field="practice.practiceName"></p-sortIcon></th>
                                        <th style="width: 3rem;"></th>
                                        <th>Locations</th>
                                        <th pSortableColumn="practiceCost">Total Price <p-sortIcon
                                                field="practiceCost"></p-sortIcon></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-mrf let-expanded="expanded">
                                    <tr [pSelectableRow]="mrf">
                                        <td>
                                            <button type="button" pButton pRipple [pRowToggler]="mrf"
                                                class="p-button-text p-button-rounded p-button-plain"
                                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                                        </td>
                                        <td>{{mrf.practice.practiceName}}</td>
                                        <td>
                                            <button type="button" pButton pRipple
                                                class="p-button-text p-button-rounded p-button-plain"
                                                icon="pi pi-pencil"
                                                (click)="showPracticeEditor[mrf.practice.ein] = true"></button>
                                            <p-dialog appendTo="body" header="Edit Practice"
                                                [(visible)]="showPracticeEditor[mrf.practice.ein]"
                                                [style]="{width: '900px', 'max-height': '800px' }">
                                                <app-practice-editor *ngIf="showPracticeEditor[mrf.practice.ein]"
                                                    [modelId]="mrf.practice.ein"></app-practice-editor>
                                            </p-dialog>
                                        </td>
                                        <td>
                                            <app-location-tag *ngFor="let location of mrf.locations"
                                                [location]="location"></app-location-tag>
                                        </td>
                                        <td>{{mrf.practiceCost | currency}}</td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="rowexpansion" let-mrf>
                                    <tr>
                                        <td colspan="4">
                                            <div>
                                                <p-table [value]="mrf.procedureBasedResults" dataKey="Procedure.procId">
                                                    <ng-template pTemplate="header">
                                                    <tr>
                                                        <th>Procedure</th>
                                                        <th>Description</th>
                                                        <th>Price</th>
                                                    </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-proc>
                                                        <tr>
                                                            <td>{{proc.procedure.code}}</td>
                                                            <td>{{proc.procedure.displayText}}</td>
                                                            <td>{{proc.topMRF.price | currency}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </p-accordionTab>
                        <p-accordionTab *ngIf="cgiCandidate" header="TEAL Results">

                            <p-table *ngIf="tealResults != null" [value]="tealResults" dataKey="practiceLocationId"
                                selectionMode="single" [(selection)]="selectedTealResult"
                                (onRowSelect)="TealChosen($event)" (onRowUnselect)="TealChosen($event)"
                                sortField="practiceCost" dataKey="closestLocation.location.locationId">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="practiceName">Practice Name <p-sortIcon
                                                field="practiceName"></p-sortIcon></th>
                                        <th pSortableColumn="distance">Distance (miles)<p-sortIcon
                                                field="closestLocation"></p-sortIcon></th>
                                        <th>Location</th>
                                        <th pSortableColumn="practiceCost">Total Price <p-sortIcon
                                                field="practiceCost"></p-sortIcon></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-teal let-expanded="expanded">
                                    <tr [pSelectableRow]="teal"
                                        [pSelectableRowDisabled]="!tealRowHasSavings(teal)"
                                        [class.teal-row-ineligible]="!tealRowHasSavings(teal)">
                                        <!-- <td>
                                            <button type="button" pButton pRipple [pRowToggler]="teal"
                                                class="p-button-text p-button-rounded p-button-plain"
                                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                                        </td> -->
                                        <td>{{teal.practiceName}}</td>
                                        <td>{{teal.closestLocation.distance.length | number: '1.0-2'}}</td>
                                        <td>{{teal.closestLocation.location.street1}} {{teal.closestLocation.location.street2}}<br>{{teal.closestLocation.location.city}}, {{teal.closestLocation.location.state}} {{teal.closestLocation.location.zip}}</td>
                                        <td>
                                            {{teal.calculatePatientCost(providerToBeatAmount) | currency}}
                                            <div *ngIf="!tealRowHasSavings(teal)" class="teal-no-savings">No savings</div>
                                        </td>
                                    </tr>
                                </ng-template>
                                <!-- <ng-template let-teal pTemplate="rowexpansion">
                                    <tr>
                                        <td colspan="5">
                                            <div style="width: 75%;margin:0 auto;">
                                                <p-table [value]="teal.codes" dataKey="Procedure.procId">
                                                    <ng-template pTemplate="header">
                                                    <tr>
                                                        <th>Code</th>
                                                        <th>Description</th>
                                                        <th>Price</th>
                                                    </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-code>
                                                        <tr>
                                                            <td>{{code.code}}</td>
                                                            <td>{{code.description}}</td>
                                                            <td>{{code.price | currency}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template> -->
                            </p-table>
                        </p-accordionTab>
                    </p-accordion>
                </div>
            </p-accordionTab>
        </p-accordion>
    </div>
    <div style="height: 2%; max-height:2%; min-height:2%;"></div>
    <div class="scroll-overflow" style="height: 28%; max-height:28%; min-height:28%;">
        <div class="grid">
            <div class="col-5">
                <p-card header="Selected Provider">

                    <div style="font-size:medium;font-weight: bold;font-style: italic;">
                        {{selectedPracticeResult?.practice?.practiceName ?? selectedPracticeResult?.practiceName}}
                    </div>
                    <div *ngIf="selectedPracticeResult != null">
                        <p-table [value]="selectedPracticeResult.locations" [(selection)]="selectedLocation"
                            dataKey="location.locationId" (onRowSelect)="locationRowSelected($event)"
                            (onRowUnselect)="locationRowDeselected($event)">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 3rem;"></th>
                                    <th>Address</th>
                                    <!--
                                    <th>Street 1</th>
                                    <th>Street 2</th>
                                    <th>City</th>
                                    <th>State</th>
                                    <th>Zip Code</th>
                                    -->
                                    <th>Distance</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-location>
                                <tr>
                                    <td style="width:3rem;">
                                        <p-tableRadioButton [value]="location"></p-tableRadioButton>
                                    </td>
                                    <td>{{location.location.street1}} {{location.location.street2}}<br>
                                        {{location.location.city}} {{location.location.state}} {{location.location.zip}}</td>
                                    <!--
                                    <td>{{location.location.street1}}</td>
                                    <td>{{location.location.street2}}</td>
                                    <td>{{location.location.city}}</td>
                                    <td>{{location.location.state}}</td>
                                    <td>{{location.location.zip}}</td>
                                    -->
                                    <td>{{location.distance.length | number: '1.0-2' }} {{location.distance.units}}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                </p-card>
            </div>
            <div class="col-7">
                <!--
                <p-card header="Selected Lines">
                -->
                <p-card>
                    <ng-template pTemplate="header">
                        <div style="display:flex;align-items:center;justify-content:space-between;">
                        <span style="font-size:1.5rem;font-weight:700">Selected Lines</span>
                        <p-button
                            label="Delete All"
                            icon="pi pi-trash"
                            (click)="clearAllSelections(); fireLinesSelected()">
                        </p-button>
                        </div>
                    </ng-template>
                    <p-table [value]="pseudoInstance" dataKey="line.lineId">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width:7rem;text-align: center;">Code</th>
                                <th style="width:7rem;text-align: center;">Description</th>
                                <th style="width:7rem;text-align: right;">Unit Cost</th>
                                <th style="width:4rem;text-align: center;">Units</th>
                                <th style="width: 10rem;text-align: right;">Total Cost</th>
                                <th style="width:3rem"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-model>
                            <tr>
                                <td style="width:7rem;text-align: center;">{{model.procedure?.code}}</td>
                                <td style="width:7rem">{{model.procedure?.displayText}}</td>
                                <td style="width:7rem;text-align: right;">{{model.unitCost | currency }}</td>
                                <td style="width:4rem;text-align: center;">{{model.units}}</td>
                                <td style="width: 10rem;text-align: right;">{{model.cost | currency}}</td>
                                <td style="width: 3rem;text-align: center;">
                                    <p-confirmPopup appendTo="body"></p-confirmPopup>
                                    <button *ngIf="!tealProviderSelected" pButton pRipple type="button" icon="pi pi-trash"
                                        (click)="deletePseudoLine(model)"
                                        class="p-button-rounded p-button-text p-button-danger"></button>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <tr>
                                <td style="text-align: center;">Total</td>
                                <td style="width:7rem"> <span *ngIf="!tealProviderSelected && pendingEncounterProvider != null"> Override
                                        <p-inputSwitch [(ngModel)]="pendingEncounterProvider.override"
                                            (onChange)="encounterProviderChange.emit(pendingEncounterProvider)"></p-inputSwitch></span>
                                </td>
                                <td style="width:7rem;text-align: right;">
                                    <span *ngIf="pendingEncounterProvider != null">
                                        {{((!tealProviderSelected || pseudoInstanceTotalUnitCost <= providerToBeat.cost)?pseudoInstanceTotalUnitCost:providerToBeat.cost) | currency}}<br>
                                    </span>
                                </td>
                                <td style="width:4rem;text-align: center;">
                                    <span *ngIf="pendingEncounterProvider != null">
                                        {{pseudoInstanceTotalUnits}}
                                    </span>
                                </td>
                                <td style="width: 10rem;text-align: right;">
                                    <span *ngIf="pendingEncounterProvider != null && !pendingEncounterProvider.override">
                                        {{((!tealProviderSelected || pendingEncounterProvider.cost <= providerToBeat.cost)?pendingEncounterProvider.cost:providerToBeat.cost) | currency }}<br>
                                    </span>
                                    <span *ngIf="pendingEncounterProvider != null && pendingEncounterProvider.override">
                                        <span class="p-float-label">
                                            <p-inputNumber [inputStyle]="{'max-width':'8rem'}"
                                                [(ngModel)]="pendingEncounterProvider.costOverride" mode="currency"
                                                inputId="costOverride" currency="USD" locale="en-US"
                                                (onInput)="encounterProviderChange.emit(pendingEncounterProvider)"></p-inputNumber>
                                            <label for="costOverride">Cost Override</label>
                                        </span>
                                    </span>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <div *ngIf="tealProviderSelected && pseudoInstanceTotalUnitCost > providerToBeat.cost" style="color:#880000;font-weight: bold;text-align: center;">(Teal price capped at Provider To Beat amount)</div>
                </p-card>
            </div>
        </div>
    </div>
</div>